import React, { useEffect, useState } from 'react';
import { DataGridIdentifiers } from '../../Interface/Datagrid/DataGridIdentifiers';
import { AutoCompleteSelectUI, ButtonUI, DialogUI, FileTabUI, FileUploadUI } from '../../Interface';
import { Box } from '@mui/material';
import { FormType } from '../../../config/form';
import productionService from '../../../service/production.service';
import supportingDocumentTypeService from '../../../service/supportingDocumentType.service';
import { SupportingDocumentSource } from '../../../config/supportingDocument';
import { generateAutocompleteItems } from '../../../utils/helper';

const JmEasyAttachmentDialog = ({ dialogData, handleClose, userId, params }) => {
  const { open, attachments, productionId } = dialogData;
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [supportingDocumentTypeOptions, setSupportingDocumentTypeOptions] = useState([]);

  useEffect(() => {
    if (!open || params?.ENABLE_SUPPORTING_DOC !== 'Y') return;

    supportingDocumentTypeService.getExternalItems().then((data) => {
      const productionInstructionTypes = (data ?? []).filter(
        (type) =>
          type.generated === false && type.source === SupportingDocumentSource.FINISHED_PRODUCT_PRODUCTION_INSTRUCTION
      );

      setSupportingDocumentTypeOptions(generateAutocompleteItems(productionInstructionTypes, 'name', 'id'));
    });
  }, [open, params?.ENABLE_SUPPORTING_DOC]);

  const handleUpload = () => {
    const formData = new FormData();

    for (const file of filesToUpload) {
      formData.append('files', file.file);
    }

    formData.append(
      'data',
      JSON.stringify({
        productionAttachment: filesToUpload.map((file) => ({
          name: file.file.name,
          supportingDocumentTypeId: file.supportingDocumentTypeId ?? null,
        })),
      })
    );

    productionService.uploadProductionAttachments(formData, productionId, userId).then(() => {
      setFilesToUpload([]);
      handleClose();
    });
  };

  const handleFilesChange = (newFiles) => {
    setFilesToUpload((currentFiles) =>
      newFiles.map((file) => ({
        ...file,
        supportingDocumentTypeId:
          currentFiles.find((currentFile) => currentFile.file === file.file)?.supportingDocumentTypeId ?? null,
      }))
    );
  };

  const handleSupportingDocumentTypeChange = (fileToUpdate, supportingDocumentTypeId) => {
    setFilesToUpload((currentFiles) =>
      currentFiles.map((file) => (file.file === fileToUpdate.file ? { ...file, supportingDocumentTypeId } : file))
    );
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
        },
      }}
    >
      <FileUploadUI onFilesChange={handleFilesChange} />
      {params?.ENABLE_SUPPORTING_DOC === 'Y' &&
        filesToUpload.map((file) => (
          <Box key={`${file.file.name}-${file.file.lastModified}`} mx="1rem" mb="0.5rem">
            <AutoCompleteSelectUI
              id={`supportingDocumentTypeId-${file.file.name}-${file.file.lastModified}`}
              label={`${file.file.name} – Kísérő dokumentum típus`}
              dataset={supportingDocumentTypeOptions}
              selectedValue={file.supportingDocumentTypeId}
              onChange={(_event, value) => handleSupportingDocumentTypeChange(file, value?.value ?? null)}
            />
          </Box>
        ))}
      <Box mt="1rem">
        <FileTabUI
          datagridIdentifier={DataGridIdentifiers.uploadFileWithSource}
          savedFiles={attachments ?? []}
          parentObj={FormType.PRODUCTION}
        />
      </Box>
      <Box display="flex" gap={3} justifyContent="center" mt="1rem">
        <ButtonUI
          text="Feltöltés"
          className="bg-success flex gap-2 items-center"
          type="button"
          disabled={!filesToUpload?.length > 0}
          onClick={handleUpload}
        />
        <ButtonUI
          text="Mégse"
          className="bg-danger flex items-center gap-2"
          type="button"
          onClick={() => handleClose()}
        >
          Bezárás
        </ButtonUI>
      </Box>
    </DialogUI>
  );
};

export default JmEasyAttachmentDialog;
